T.SearchEvents = {};

/** @typedef {{switchToMapButton:Boolean,isVirtual:Boolean,disableDirectLinks:Boolean,kw:String|null,tag:String|null,onChange:Function,onResearch:Function|null}} T.SearchEvents.AutoComplete.Par */
/**
 * @class
 * @param {T.SearchEvents.AutoComplete.Par} par
 * @extends mkE.Base
 */
T.SearchEvents.AutoComplete = Class(
	/**
	 * @lends {T.SearchEvents.AutoComplete#}
	 */
	{
		/** @type {string|null} */
		_lastKeyword: null,
		/** @param {T.SearchEvents.AutoComplete.Par} par */
		__construct: function (par) {
			this.par = par;
			let searchTerm = '';
			if (par.tag) {
				searchTerm = par.tag;
			} else if (par.kw) {
				searchTerm = par.kw;
			}
			if (searchTerm) {
				this._lastKeyword = searchTerm;
			}
			this.node = mkE({
				tag: 'div',
				className: 't__search_events__auto_complete',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							this._input = new T.Form.AutoComplete({
								placeholder: D.Lang.get('events.search.placeholder'),
								border: true,
								onKeyUp: this._onKeyUp,
								onChange: this._onChange,
								button: {
									tag: 'a',
									className: 'button button-pink',
									onclick: this._onClickSearch
								},
								value: searchTerm,
								clear: true
							}),
							this.par.switchToMapButton ? {
								tag: 'a',
								className: 'button button-transparent button-map',
								onclick: this.par.switchToMapButton,
								els: [
									D.Lang.get('events.search.map'),
									D.svgIcon('map')
								]
							} : ''
						]
					}
				]
			});
			this._mGetSearchTags = new DR.events.GetSearchTags();
			this._mGetSearchTags.onLoad = this._mGetSearchTagsRe;
			this._mGetSearchTags.isVirtual = this.par.isVirtual || null;
			this._mGetSearchTags.call();
		},
		reset() {
			this._input.value('');
		},
		/** @return {String} */
		value() {
			return String(this._input.value());
		},
		/** @return {String|null} */
		valueTag() {
			const kw = this.value();
			if (!kw) {
				return null;
			}
			if (kw === this.par.tag) {
				return kw;
			}
			if (!this.tagList) {
				return null;
			}
			const tagIndex = this.tagList.indexOf(this._normalize(kw));
			if (tagIndex === -1) {
				return null;
			}
			return this.tagList[tagIndex];
		},
		_mGetSearchTagsRe() {
			this.tags = [];
			this.tagList = [];
			for (let i = 0; i < this._mGetSearchTags.re.tags.length; i++) {
				const tag = this._mGetSearchTags.re.tags[i];
				const tagNormalized = this._normalize(tag.tag);
				if (tag.eventUrl) {
					this.tags.push([tag.tag, tagNormalized, tag.eventUrl]);
				} else {
					this.tags.push([tag.tag, tagNormalized]);
					this.tagList.push(tagNormalized);
				}
			}
		},
		/** @param {KeyboardEvent|MouseEvent|null} e */
		_onChange(e = null) {
			clearTimeout(this._to);
			const kw = this._input.value();
			if (this._lastKeyword === kw) {
				if (this.par.onResearch) {
					this.par.onResearch();
				}
				return;
			}
			this._lastKeyword = kw;
			this.par.onChange(e);
			if (e !== null) {
				D.Analytics.fbq('Search', {
					search_string: kw
				});
			}
		},
		/** @param {KeyboardEvent} e */
		_onKeyUp(e) {
			if (e.code === "Enter" || e.keyCode === 13) {
				this._input.blur();
			} else {
				this._populateAutoComplete();
				clearTimeout(this._to);
				this._to = setTimeout(this._onAutoSearch, 1000);
			}
		},
		/** @param {MouseEvent} e */
		_onClickSearch(e) {
			if (this._input.hasFocus()) {
				this._input.blur();
			} else {
				this._onChange(e);
			}
		},
		_onAutoSearch() {
			const kw = this._input.value().trim();
			if (kw.length > 0 && kw.length < 3) {
				return;
			}
			this._onChange();
		},
		_normalize(str) {
			return str.toLowerCase().normalize('NFKD').replace(/[^\w\s]/g, '');
		},
		_populateAutoComplete() {
			const value = this._normalize(this._input.value()) || '';
			const tags = [];
			if (value.length > 0 && this.tags.length > 0) {
				for (let i = 0; i < this.tags.length; i++) {
					const tag = this.tags[i];
					if (tag[1].search(value) === 0) {
						if (tag[2] && !this.par.disableDirectLinks) {
							tags.push({
								caption: tag[0],
								value: tag[0],
								href: D.url('/event/' + tag[2])
							});
						} else {
							tags.push({
								caption: tag[0],
								value: tag[0]
							});
						}
					}
					if (tags.length >= 5) {
						break;
					}
				}
			}
			this._input.setAutocompleteItems(tags);
		}
	},
	mkE.Base
);
/**
 * @typedef {{
 * sortType:String,
 * transportType:String[]|null,
 * country:String|null,
 * isVirtual:Boolean|null,
 * filterCountry:Boolean,
 * apiCall:DR.ApiCall,
 * method:DR.events.GetFilter
 * }} T.SearchEvents.Filter.Par
 */
/**
 * @class
 * @param {T.SearchEvents.Filter.Par} par
 * @extends mkE.Base
 */
T.SearchEvents.Filter = Class(
	/**
	 * @lends {T.SearchEvents.Filter#}
	 */
	{
		/** @type {T.PopupModal} */
		_filterPopup: null,
		/** @param {T.SearchEvents.Filter.Par} par */
		__construct: function (par) {
			if (par.country === 'en') {
				par.country = null;
			} else if (par.country === 'et') {
				par.country = 'ee';
			}
			par.transportType = par.transportType || [];
			par.filterCountry = par.filterCountry !== false;
			this.par = par;
			this.node = mkE({
				tag: 'div',
				className: 't__search_events__filter'
			});
			if (par.method) {
				this._mGetFilter = par.method;
				this._mGetFilterRe();
			} else {
				this._mGetFilter = new DR.events.GetFilter();
				this._mGetFilter.onLoad = this._mGetFilterRe;
				this._mGetFilter.isVirtual = this.par.isVirtual || null;
				if (par.apiCall) {
					par.apiCall.addMethod(this._mGetFilter);
				} else {
					this._mGetFilter.call();
				}
			}
		},
		_mGetFilterRe() {
			let sortOptions = [
				{value: DR.events.Search.SORTTYPE_NEWEST, caption: D.Lang.get('events.filter.type.newest')},
				{value: DR.events.Search.SORTTYPE_DISTANCE, caption: D.Lang.get('events.filter.type.closest')},
				{value: DR.events.Search.SORTTYPE_RATING, caption: D.Lang.get('events.filter.type.rating')},
				{value: DR.events.Search.SORTTYPE_POPULARITY, caption: D.Lang.get('events.filter.type.popularity')}
			];
			mkE({
				tag: 'div',
				className: 'container',
				els: [
					{
						tag: 'div',
						className: 'col col-sort_type',
						els: [
							this._filterSortType = new T.Form.Select({
								caption: D.Lang.get('events.filter.sortType.label'),
								border: true,
								name: 'sortType',
								onChange: this._onChange,
								value: this.par.sortType || '',
								options: sortOptions
							})
						]
					},
					{
						tag: 'div',
						className: 'col col-mobile',
						els: [
							this._filterPopupButton = mkE({
								tag: 'a',
								className: 'button button-gray button-form button-icon button-icon-filter',
								onclick: this._onClickOpenFilter,
								els: [
									D.svgIcon('filter'),
									D.Lang.get('events.filter.filter')
								]
							})
						]
					},
					{
						tag: 'div',
						className: 'col col-transport_type advanced-filter',
						els: [
							{
								tag: 'label',
								els: [
									this._filterTransportTypeFoot = mkE({
										tag: 'input',
										type: 'checkbox',
										name: 'transportType',
										onchange: this._onChange,
										value: DR.events.Search.TRANSPORTTYPE_FOOT,
										checked: this.par.transportType.indexOf(DR.events.Search.TRANSPORTTYPE_FOOT) > -1
									}),
									{
										tag: 'span',
										className: 'button button-gray button-form button-transport_type',
										els: [
											D.svgIcon('transport-type-foot'),
											D.Lang.get('events.filter.transportType.foot')
										]
									}
								]
							},
							{
								tag: 'label',
								els: [
									this._filterTransportTypeCar = mkE({
										tag: 'input',
										type: 'checkbox',
										name: 'transportType',
										onchange: this._onChange,
										value: DR.events.Search.TRANSPORTTYPE_CAR,
										checked: this.par.transportType.indexOf(DR.events.Search.TRANSPORTTYPE_CAR) > -1
									}),
									{
										tag: 'span',
										className: 'button button-gray button-form button-transport_type',
										els: [
											D.svgIcon('transport-type-car'),
											D.Lang.get('events.filter.transportType.car')
										]
									}
								]
							},
							{
								tag: 'label',
								els: [
									this._filterTransportTypeBicycle = mkE({
										tag: 'input',
										type: 'checkbox',
										name: 'transportType',
										onchange: this._onChange,
										value: DR.events.Search.TRANSPORTTYPE_BICYCLE,
										checked: this.par.transportType.indexOf(DR.events.Search.TRANSPORTTYPE_BICYCLE) > -1
									}),
									{
										tag: 'span',
										className: 'button button-gray button-form button-transport_type',
										els: [
											D.svgIcon('transport-type-bicycle'),
											D.Lang.get('events.filter.transportType.bicycle')
										]
									}
								]
							}
						]
					},
					this.par.filterCountry ? {
						tag: 'div',
						className: 'col col-country advanced-filter',
						els: [
							this._filterCountry = new T.Form.Select({
								caption: D.Lang.get('events.filter.country.label'),
								border: true,
								name: 'country',
								onChange: this._onChange,
								value: this.par.country || '',
								options: (() => {
									let options = [{
										value: '',
										caption: D.Lang.get('events.filter.country.all')
									}];
									for (let i = 0; i < this._mGetFilter.re.countries.length; i++) {
										const country = this._mGetFilter.re.countries[i];
										options.push({
											value: country,
											caption: D.Lang.get(`iso.countries.${country}`)
										})
									}
									return options;
								})()
							})
						]
					} : ''
				]
			}).append(this.node);
			this._setPopupFilterStatus();
		},
		/** @return {String|null} */
		getCountry() {
			if (!this.par.filterCountry) {
				return null;
			}
			return String(this._filterCountry.value()) || null;
		},
		/** @return {String[]|null} */
		getTransportType() {
			let transportType = [];
			if (this._filterTransportTypeFoot.checked) {
				transportType.push(DR.events.Search.TRANSPORTTYPE_FOOT);
			}
			if (this._filterTransportTypeCar.checked) {
				transportType.push(DR.events.Search.TRANSPORTTYPE_CAR);
			}
			if (this._filterTransportTypeBicycle.checked) {
				transportType.push(DR.events.Search.TRANSPORTTYPE_BICYCLE);
			}
			return transportType.length ? transportType : null;
		},
		/** @return {String|null} */
		getSortType() {
			return this._filterSortType.value() || null;
		},
		reset() {
			this._filterSortType.value(DR.events.Search.SORTTYPE_NEWEST, false);
			this._filterTransportTypeBicycle.checked = false;
			this._filterTransportTypeFoot.checked = false;
			this._filterTransportTypeCar.checked = false;
			this._filterCountry.value(this.par.country, false);
		},
		/** @param {MouseEvent|null} e */
		_onChange(e = null) {
			this._setPopupFilterStatus();
			this.par.onChange();
		},
		_onClickOpenFilter() {
			this._filterPopupFormNode = mkE({
				tag: 'form',
				className: 't__search_events__filter--popup',
				attr: {
					onsubmit: "return false;"
				},
				els: [
					{
						tag: 'a',
						className: 'reset',
						onclick: this._resetPopupFilter,
						text: D.Lang.get('events.filter.reset')
					},
					{
						tag: 'div',
						className: 'popup-title',
						text: D.Lang.get('events.filter.popup')
					},
					{
						tag: 'div',
						className: 'row-buttons',
						els: [
							{
								tag: 'label',
								className: 'label-button',
								els: [
									this._filterPopupFormTransportFoot = mkE({
										tag: 'input',
										type: 'checkbox',
										name: 'filter_p[transportType]',
										value: DR.events.Search.TRANSPORTTYPE_FOOT,
										checked: this._filterTransportTypeFoot.checked
									}),
									{
										tag: 'span',
										className: 'button button-gray button-form button-transport_type',
										els: [
											D.svgIcon('transport-type-foot'),
											D.Lang.get('events.filter.transportType.foot')
										]
									}
								]
							},
							{
								tag: 'label',
								className: 'label-button',
								els: [
									this._filterPopupFormTransportCar = mkE({
										tag: 'input',
										type: 'checkbox',
										name: 'filter_p[transportType]',
										value: DR.events.Search.TRANSPORTTYPE_CAR,
										checked: this._filterTransportTypeCar.checked
									}),
									{
										tag: 'span',
										className: 'button button-gray button-form button-transport_type',
										els: [
											D.svgIcon('transport-type-car'),
											D.Lang.get('events.filter.transportType.car')
										]
									}
								]
							},
							{
								tag: 'label',
								className: 'label-button',
								els: [
									this._filterPopupFormTransportBicycle = mkE({
										tag: 'input',
										type: 'checkbox',
										name: 'filter_p[transportType]',
										value: DR.events.Search.TRANSPORTTYPE_BICYCLE,
										checked: this._filterTransportTypeBicycle.checked
									}),
									{
										tag: 'span',
										className: 'button button-gray button-form button-transport_type',
										els: [
											D.svgIcon('transport-type-bicycle'),
											D.Lang.get('events.filter.transportType.bicycle')
										]
									}
								]
							}
						]
					},
					this.par.filterCountry ? {
						tag: 'div',
						className: 'filter-popup-country',
						els: [
							this._filterPopupFormCountry = new T.Form.Select({
								caption: D.Lang.get('events.filter.country.label'),
								border: true,
								name: 'filter_p[country]',
								value: this._filterCountry.value(),
								options: (() => {
									let re = [{
										value: '',
										caption: D.Lang.get('events.filter.country.all')
									}];
									for (let i = 0; i < this._mGetFilter.re.countries.length; i++) {
										const country = this._mGetFilter.re.countries[i];
										re.push({
											value: country,
											caption: D.Lang.get(`iso.countries.${country}`)
										})
									}
									return re;
								})()
							})
						]
					} : '',
					{
						tag: 'div',
						els: [
							{
								tag: 'a',
								onclick: this._onChangePopupFilter,
								className: 'button button-block button-pink',
								text: D.Lang.get('events.filter.filter')
							}
						]
					}
				]
			});

			if (!this._filterPopup) {
				this._filterPopup = new T.PopupModal({
					isFullscreen: true
				}).append(this.node);
			}
			this._filterPopup.setContent(this._filterPopupFormNode);
			this._filterPopup.open();
		},
		_resetPopupFilter() {
			if (this._filterPopup) {
				this._filterPopup.close();
			}
			this.reset();
		},
		_onChangePopupFilter() {
			if (this._filterPopup) {
				this._filterPopup.close();
			}
			if (this.par.filterCountry) {
				this._filterCountry.value(this._filterPopupFormCountry.value(), false);
			}
			this._filterTransportTypeFoot.checked = this._filterPopupFormTransportFoot.checked;
			this._filterTransportTypeCar.checked = this._filterPopupFormTransportCar.checked;
			this._filterTransportTypeBicycle.checked = this._filterPopupFormTransportBicycle.checked;
			this._onChange();
		},
		_setPopupFilterStatus() {
			if (!this._filterPopupButton) {
				return;
			}
			if (this.getTransportType() !== null || this.getCountry()) {
				addClassName(this._filterPopupButton, 'active');
			} else {
				removeClassName(this._filterPopupButton, 'active');
			}
		}
	},
	mkE.Base
);